'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useMemo } from 'react';
import { useLFSearchParams } from '@services/useLFSearchParams';
import { RootStoreContext } from '@stores/rootStore';
import { isPresent } from '@farmai-shared/LFUtils';
import { useAdministrativeLevelsQuery } from './useAdministrativeLevels';
import { SupportedLanguageKeys } from '@services/responseTypes';
export const useActiveCountry = () => {
  const $ = _c(29);
  const {
    uiStore,
    userStore
  } = useContext(RootStoreContext);
  const lang = userStore.user.settings.lang as SupportedLanguageKeys;
  const {
    searchParams,
    setParam
  } = useLFSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("filter[country]");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const countryParam = t0;
  let t1;
  if ($[2] !== uiStore.currentOrganization) {
    t1 = {
      level: "country",
      fetchAdministrativeLevels: async () => {
        if (!uiStore.currentOrganization) {
          return {
            countries: []
          };
        }
        const {
          data
        } = await uiStore.currentOrganization.fetchAdministrativeLevels();
        return data;
      }
    };
    $[2] = uiStore.currentOrganization;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: t2,
    isLoading
  } = useAdministrativeLevelsQuery(t1);
  let t3;
  if ($[4] !== t2) {
    t3 = t2 === undefined ? {
      countries: [] as {
        en: string;
        native: string;
      }[]
    } : t2;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const administrativeLevels = t3;
  const countries = administrativeLevels.countries;
  let t4;
  bb0: {
    if (!countryParam || !isPresent(countries)) {
      t4 = null;
      break bb0;
    }
    let t5;
    if ($[6] !== countries || $[7] !== countryParam) {
      t5 = countries.find(c => [c.en, c.native].some(v => v === countryParam)) ?? null;
      $[6] = countries;
      $[7] = countryParam;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = t5;
  }
  const activeCountry = t4;
  let t5;
  bb1: {
    if (!activeCountry) {
      t5 = countryParam ?? undefined;
      break bb1;
    }
    t5 = activeCountry[lang] || activeCountry.en || activeCountry.native;
  }
  const activeCountryLabel = t5;
  let t6;
  if ($[9] !== setParam) {
    t6 = next => {
      setParam("filter[country]", next);
    };
    $[9] = setParam;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const setActiveCountry = t6;
  let t7;
  if ($[11] !== countries || $[12] !== isLoading || $[13] !== searchParams || $[14] !== setActiveCountry || $[15] !== uiStore.currentOrganization) {
    t7 = () => {
      if (isLoading) {
        return;
      }
      if (!searchParams.has("filter[country]") && Array.isArray(countries) && countries.length > 1) {
        uiStore.currentOrganization?.fetchCountryWithMostFields().then(country => {
          if (country) {
            const matchingCountry = countries.find(c_0 => c_0.en === country || c_0.native === country);
            if (matchingCountry) {
              const val = matchingCountry.en || matchingCountry.native;
              if (val) {
                setActiveCountry(val);
              }
              return;
            }
          }
          const only = countries[0];
          const val_0 = only.en || only.native;
          if (val_0) {
            setActiveCountry(val_0);
          }
        });
      }
    };
    $[11] = countries;
    $[12] = isLoading;
    $[13] = searchParams;
    $[14] = setActiveCountry;
    $[15] = uiStore.currentOrganization;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const t8 = uiStore.currentOrganization?.id;
  let t9;
  if ($[17] !== countries || $[18] !== isLoading || $[19] !== searchParams || $[20] !== t8) {
    t9 = [isLoading, countries, searchParams, t8];
    $[17] = countries;
    $[18] = isLoading;
    $[19] = searchParams;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  useEffect(t7, t9);
  let t10;
  if ($[22] !== activeCountry || $[23] !== activeCountryLabel || $[24] !== countries || $[25] !== countryParam || $[26] !== isLoading || $[27] !== setActiveCountry) {
    t10 = {
      countryParam,
      countries,
      activeCountry,
      activeCountryLabel,
      isLoading,
      setActiveCountry
    };
    $[22] = activeCountry;
    $[23] = activeCountryLabel;
    $[24] = countries;
    $[25] = countryParam;
    $[26] = isLoading;
    $[27] = setActiveCountry;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};